import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GuideApi } from '../../api/guide-api';
import { HighGuideFilter } from '../../models/guide/high-guide-filter';
import { FileSystemService } from '../../services/file-system.service';
import { FetchOptions } from '../base/fetch-strategy';
import { Repository } from '../base/repository';

/**
 * Data-access layer for HighGuide filter resources.
 *
 * The dashboard does not render these itself - they are relayed into the embedded HighGuide iframe - but they are
 * fetched and cached here because the iframe holds no session of its own.
 */
@Injectable()
export class FiltersRepository extends Repository {
  constructor(
    fileSystemService: FileSystemService,
    protected guideAPI: GuideApi
  ) {
    super(fileSystemService);
  }

  private readonly highGuideFiltersDataKey = 'highGuideFilters';

  /**
   * The location's full filter list. Always fetched unfiltered - the id-filtered variant is a separate, uncached
   * method, because both would share this cache entry and a subset written here would stand in for the whole list
   * on the next cold load.
   */
  public getFilters$(companyId: number, locationId: number, opts?: FetchOptions): Observable<HighGuideFilter[] | null> {
    return this.loadArray$(
      HighGuideFilter,
      companyId,
      locationId,
      this.highGuideFiltersDataKey,
      this.guideAPI.getFilters$(),
      opts
    );
  }

  /**
   * Uncached: returns only the named filters. See `getFilters$`.
   */
  public getFiltersByIds$(ids: string[]): Observable<HighGuideFilter[]> {
    return this.guideAPI.getFilters$(ids);
  }
}
